import React from "react";
import EventsManager from "components/FeedEvents/EventsManager";
import HardcodedUpcomingEventCard from "components/FeedEvents/HardcodedUpcomingEventCard";
import { canManageDashboardEvents } from "components/FeedEvents/feedEvents.utils";
import "components/FeedEvents/FeedEvents.css";

/**
 * The webinar card is hardcoded for now. Upcoming events from Super Admin
 * render in this same tab and will take this slot when the card is removed.
 */
export const SHOW_HARDCODED_UPCOMING_EVENT = true;

const EventsTab = () => {
  const canManage = canManageDashboardEvents();

  return (
    <div className="feed-events">
      {SHOW_HARDCODED_UPCOMING_EVENT ? (
        <div className="mb-3">
          <HardcodedUpcomingEventCard />
        </div>
      ) : null}
      <EventsManager
        canManage={canManage}
        showEmpty={!SHOW_HARDCODED_UPCOMING_EVENT}
      />
    </div>
  );
};

export default EventsTab;
